import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PlanItem from '../PlanItem';

export default function PricingItem({ pricingItem }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pricing__item-container">
      <div className="pricing__content-group">
        {pricingItem.isMostPopular && (
          <img
            className="pricing__most-popular"
            src="/images/pricing/most-popular.png"
            alt="most popular"
          />
        )}
        <img
          className="pricing-item__logo"
          src={pricingItem.logo}
          alt={pricingItem.title}
        />
        <button type="button" className="pricing-item__get-started">
          <Link
            to="/contact-us"
            state={{
              plan: pricingItem.title,
              unit: pricingItem.unit
            }}
          >
            CONTACT US
          </Link>
        </button>
        <hr />
        <div
          className={
            isExpanded
              ? 'pricing-item__info-group-expand'
              : 'pricing-item__info-group'
          }
        >
          <span className="pricing-item__plan-include">Plan includes:</span>
          {pricingItem.pricingPlanItem.map((planItem) => (
            <PlanItem key={planItem} planItemText={planItem} />
          ))}
        </div>
        <div className={isExpanded ? '' : 'pricing-item__blur-plan-item'} />
        <button
          type="button"
          aria-label="pricing-item__expand-icon"
          className="pricing-item__expand-icon"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <i
            className={`pricing-item__rotate ${
              isExpanded
                ? 'pricing-item__rotate-icon-expanded'
                : 'pricing-item__rotate-icon'
            }`}
          />
        </button>
      </div>
    </div>
  );
}

PricingItem.propTypes = {
  pricingItem: PropTypes.instanceOf(Object).isRequired
};
